import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import DSCohortTableWrapper from './table/DSCohortTableWrapper';

export function DSCohortCard() {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">DS Cohort</h3>
        </Col>
      </Row>
      <Row>
        <DSCohortTableWrapper />
      </Row>
    </Container>
  );
}
